
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 50 50","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M1 9.3c6.9 5.8 18.9 16 22.4 19.2.5.4 1 .6 1.5.6s1-.2 1.5-.6C30.1 25.3 42.1 15.1 49 9.3c.4-.4.5-1 .1-1.4-.8-1-2-1.6-3.3-1.6H4.2c-1.3 0-2.5.6-3.3 1.6-.3.4-.3 1 .1 1.4zM49.4 12.4c-.4-.2-.8-.1-1.1.2-4.5 3.8-10.4 8.8-14.9 12.7-.2.2-.4.5-.4.8 0 .3.1.6.4.8 4.1 3.3 10.4 7.9 14.9 11.1.2.1.4.2.6.2.2 0 .3 0 .5-.1.3-.2.6-.5.6-.9V13.4c0-.4-.2-.8-.6-1zM1.6 38c4.5-3.2 10.8-7.8 14.9-11.1.2-.2.4-.5.4-.8 0-.3-.1-.6-.4-.8C12 21.5 6.1 16.4 1.6 12.6c-.3-.3-.7-.3-1.1-.2-.3.2-.5.6-.5 1v23.8c0 .4.2.7.6.9.1.1.3.1.5.1s.4 0 .5-.2z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M48.7 40.9c-4.4-3.1-12.4-8.9-17.2-12.8-.4-.3-1-.3-1.3 0-.9.8-1.7 1.5-2.3 2-1.7 1.5-4.1 1.5-5.8 0-.6-.5-1.3-1.2-2.3-2-.4-.3-.9-.3-1.3 0C13.7 32 5.7 37.8 1.3 40.9c-.3.1-.4.4-.5.7 0 .3.1.6.3.8.8.8 1.9 1.3 3 1.3h41.7c1.1 0 2.3-.5 3-1.3.2-.2.3-.5.3-.8 0-.3-.1-.6-.4-.7z"}})])
          )
        }
      }
    